// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2_0Dz","description":"PatientConsentPreview_description__1QdPL"};